module.exports = __webpack_public_path__ + "static/media/014.f21a59d2.jpg";